import {
  NAVIGATION_OPEN_ITEM,
  NAVIGATION_CLOSE_ITEM,
  AUTH_LOGIN_SUCCESS,
  AUTH_LOGIN_FAILURE,
  AUTH_RESET_PASSWORD_SUCCESS,
  AUTH_RESET_PASSWORD_FAILURE,
  SNACKBAR_SHOW,
  SNACKBAR_HIDE,
  MENU_OPEN,
  MENU_CLOSE,
  ASYNC_INDICATOR_SHOW,
  ASYNC_INDICATOR_HIDE,
  DISPLAY_RESET_PASSWORD,
  RESET_TMP_PASSWORD,
  CHANGE_USER_MERCHANT_SUCCESS,
  GET_USER_MERCHANTS_SUCCESS
} from "../actions";

import { push } from "react-router-redux";

import Http from "../services/http";
import Token from "../services/token";

const DEFAULT_URL = "/statistiques";

export const navigationOpenItem = to => ({
  type: NAVIGATION_OPEN_ITEM,
  to
});

export const navigationCloseItem = to => ({
  type: NAVIGATION_CLOSE_ITEM,
  to
});

export const asyncIndicatorShow = () => ({
  type: ASYNC_INDICATOR_SHOW
});

export const asyncIndicatorHide = () => ({
  type: ASYNC_INDICATOR_HIDE
});

export const menuOpen = () => ({
  type: MENU_OPEN
});

export const menuClose = () => ({
  type: MENU_CLOSE
});

export const displayLogin = () => dispatch => {
  dispatch(push("/login"));
};

export const displayResetPassword = () => ({
  type: DISPLAY_RESET_PASSWORD
});

export const snackbarShow = message => ({
  type: SNACKBAR_SHOW,
  message
});

export const snackbarHide = () => ({
  type: SNACKBAR_HIDE
});

export const snackbar = message => dispatch => {
  dispatch(snackbarShow(message));
};

export const authLoginFailure = () => ({
  type: AUTH_LOGIN_FAILURE
});

export const authLoginSuccess = token => ({
  type: AUTH_LOGIN_SUCCESS,
  ...Token.parse(token)
});

export const authLogin = (login, password, sso = false) => dispatch => {
  dispatch(asyncIndicatorShow());
  return Http.post("/auth", { login, password })
    .then(res => {
      const token = res.token;
      if (token) {
        dispatch(authLoginSuccess(token));
        if (sso) {
          window.location.href = "/statistiques";
        } else {
          dispatch(push(DEFAULT_URL));
        }
      } else {
        dispatch(displayResetPassword());
      }
    })
    .catch(err => {
      console.log(err);
      dispatch(snackbar("Identifiants invalides"));
    });
};

export const authResetPasswordSuccess = response => ({
  type: AUTH_RESET_PASSWORD_SUCCESS,
  ...Token.parse(response.token)
});

export const authResetPasswordFailure = () => ({
  type: AUTH_RESET_PASSWORD_FAILURE
});

export const authResetPassword = (login, password, newPassword) => dispatch => {
  dispatch(asyncIndicatorShow());
  return Http.post("/reset-password", { login, password, newPassword })
    .then(res => {
      dispatch(authResetPasswordSuccess(res));
      dispatch(push(DEFAULT_URL));
    })
    .catch(err => dispatch(authResetPasswordFailure(err)));
};

export const authSendPassword = login => dispatch => {
  dispatch(asyncIndicatorShow());
  return Http.post("/send-password", { login })
    .then(res => {
      dispatch(push("/"));
      dispatch(snackbar("Mot de passe renvoyé par email"));
    })
    .catch(err => {
      dispatch(snackbar("Erreur lors de l'envoi du mot de passe"));
    });
};

export const resetTmpPasswordSuccess = () => ({
  type: RESET_TMP_PASSWORD
});

export const resetTmpPassword = () => dispatch => {
  dispatch(resetTmpPasswordSuccess());
  dispatch(push("/"));
};

export const changeUserMerchantSuccess = token => ({
  type: CHANGE_USER_MERCHANT_SUCCESS,
  ...Token.parse(token)
});

export const changeUserMerchant = (merchant, user) => dispatch => {
  dispatch(asyncIndicatorShow());
  if (user.merchants.filter(m => m.merchant === merchant).length === 1) {
    return Http.post("/change-user-merchant", {
      email: user.email,
      merchant
    })
      .then(res => {
        const token = res.token;
        if (token) {
          dispatch(changeUserMerchantSuccess(token));
          window.location.href = "/statistiques";
        } else {
          dispatch(snackbar("Le marchand n'a pas pu être changé"));
        }
      })
      .catch(err => {
        console.log(err);
        dispatch(snackbar("Le marchand n'a pas pu être changé"));
      });
  }
};

export const getUserMerchantsSuccess = merchants => ({
  type: GET_USER_MERCHANTS_SUCCESS,
  merchants
});

export const getUserMerchants = login => dispatch => {
  dispatch(asyncIndicatorShow());
  return Http.post("/get-user-merchants", {
    login
  })
    .then(res => {
      const { merchants } = res;
      dispatch(getUserMerchantsSuccess(merchants));
    })
    .catch(err => {
      console.log(err);
      dispatch(snackbar("Le marchand n'a pas pu être changé"));
    });
};



// WEBPACK FOOTER //
// ./src/app/actions.js